export enum GameStateStatus {
  Bidding = 'bidding',
  StartingSet = 'starting_set',
  StartingTrick = 'starting_trick',
  Playing = 'playing',
  ScoringTrick = 'scoring_trick',
  ScoringSet = 'scoring_set',
  GameOver = 'game_over',
}

export enum Suite {
  Hearts = 'Hearts',
  Spades = 'Spades',
  Diamonds = 'Diamonds',
  Clubs = 'Clubs',
}
